import { Button, COLOR_NEUTRAL_30, COLOR_SUCCESS_50, IconCheckCircle, IconCircle, Text } from '@consumidor-positivo/aurora';
import { getMonth } from '@libs/utils/helpers/getMonth';
import UpdateContactData from '../UpdateContactData';
import HeadingSection from '../HeadingSection';
import CardSection from '../PaymentData/components/CardSection';
import { DebtData } from '@common/hooks/useDebts/types';
import { ClosedAgreementProps } from '../../types';

import './styles.scss';

interface RetryProps {
  debtData: DebtData;
  closedAgreement: ClosedAgreementProps;
  firstInstallmentExpDate: string;
  handleRedirectToMyDebts: () => void;
}

const Retry = ({ debtData, closedAgreement, firstInstallmentExpDate, handleRedirectToMyDebts }: RetryProps) => {
  const getDateDesc = () => {
    const currDate = new Date().toLocaleDateString('pt-BR');
    const formattedMonth = getMonth(currDate).full;
    const [day, , year] = currDate.split('/');
    return `${day} de ${formattedMonth}, ${year}`;
  };

  const retryStatus = [
    {
      icon: <IconCheckCircle rawColor={COLOR_SUCCESS_50} />,
      title: 'Solicitação de acordo enviada!',
      desc: getDateDesc(),
      line: <div className="retry-page__status-line" />,
    },
    {
      icon: <IconCheckCircle rawColor={COLOR_SUCCESS_50} />,
      title: 'Acordo em análise!',
      desc: 'Retorno em até 3 horas úteis',
      line: <div className="retry-page__status-line retry-page__status-line--last" />,
    },
    { icon: <IconCircle rawColor={COLOR_NEUTRAL_30} />, title: 'Acordo aprovado!', line: <></> },
  ];

  return (
    <div className="retry-page">
      <HeadingSection isRetryError debtData={debtData} />

      <div className="closed-agreement-page__container">
        <div className="retry-page__status-card">
          <Text variant="heading-micro" weight="bold">
            Status da solicitação
          </Text>
          <div className="closed-agreement-page__divider" />

          {retryStatus.map((status, index) => (
            <div className="retry-page__status-container" key={index}>
              <div>
                {status.icon}
                {status.line}
              </div>
              <div>
                <Text
                  weight="semibold"
                  {...(!status.desc && {
                    weight: 'regular',
                    color: 'secondary',
                  })}
                >
                  {status.title}
                </Text>
                {status.desc && (
                  <Text color="secondary" className="retry-page__status-desc">
                    {status.desc}
                  </Text>
                )}
              </div>
            </div>
          ))}
        </div>

        <CardSection debtData={debtData} closedAgreement={closedAgreement} firstInstallmentExpDate={firstInstallmentExpDate} isRetryError />

        <UpdateContactData partnerLogo={debtData.display.partnerImage} />

        <Button type="outlined" onClick={handleRedirectToMyDebts}>
          Voltar para a página inicial
        </Button>
      </div>
    </div>
  );
};

export default Retry;
